import { ageAtTaxYearStart } from './tax-year.js';
/**
 * The projection year a goal anchor points at, or null when it cannot be
 * resolved: the person or dependent is not on the plan, or the dependent's
 * date of birth is not a usable ISO date. Null is never defaulted to a year —
 * an unresolvable anchor makes the goal "outside the projection".
 *
 * Person ages follow the engine's `ageIn` rule (`currentAge + (year −
 * startYear)`); dependent ages follow `ageAtTaxYearStart`, so "when Dan is
 * 18" is the first tax year Dan is 18 at 6 April — the same year the
 * contribution step stops paying.
 */
export function resolveGoalAnchorYear(anchor, ctx) {
    switch (anchor.kind) {
        case 'year':
            return anchor.year;
        case 'endOfPlan':
            return ctx.endYear ?? null;
        case 'personAge': {
            const person = ctx.people.find((p) => p.id === anchor.personId);
            if (person === undefined)
                return null;
            return ctx.startYear + (anchor.age - person.currentAge);
        }
        case 'dependentAge': {
            const dep = ctx.dependents.find((d) => d.id === anchor.dependentId);
            if (dep === undefined)
                return null;
            const match = /^(\d{4})-\d{2}-\d{2}$/.exec(dep.dateOfBirth);
            if (match === null)
                return null;
            let year = Number(match[1]) + anchor.age;
            try {
                if (ageAtTaxYearStart(dep.dateOfBirth, year) < anchor.age)
                    year += 1;
            }
            catch {
                return null;
            }
            return year;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=goals.js.map